module.exports = __webpack_public_path__ + "static/allemand-8d04cb64c5dea476d06fdb6a7bd9353c.jpg";